{
  "version": 1,
  "asset_id": "6e45f82e-ced7-4534-b29d-f08b910a2633",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/6e45f82e-ced7-4534-b29d-f08b910a2633/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/6e45f82e-ced7-4534-b29d-f08b910a2633/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-768w.avif",
  "original_filename": "lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-768w.avif",
  "size": 15412,
  "content_type": "image/avif",
  "created_at": "2026-08-27T15:21:05Z"
}
